"use client";

import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "./cn";
import { Input, type InputProps } from "./input";

export type PasswordInputProps = Omit<InputProps, "type">;

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, ...props }, ref) => {
    const [visible, setVisible] = React.useState(false);

    return (
      <div className="relative">
        <Input
          ref={ref}
          type={visible ? "text" : "password"}
          className={cn("pr-10", className)}
          {...props}
        />
        <button
          type="button"
          className={cn(
            "absolute right-0 top-0 flex h-9 w-9 items-center justify-center rounded-md",
            "text-muted-foreground transition-colors duration-micro hover:text-foreground",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          )}
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          tabIndex={-1}
        >
          {visible ? (
            <EyeOff className="size-4" strokeWidth={1.6} />
          ) : (
            <Eye className="size-4" strokeWidth={1.6} />
          )}
        </button>
      </div>
    );
  },
);
PasswordInput.displayName = "PasswordInput";
